<template>
  <div>
    <div class="title">
      用户基本信息
    </div>
    <div class="fundamental">
      <div class="message">
        <div class="message_left">会员编号: {{ formInline.code }}</div>
        <div class="message_right">会员手机号: {{ formInline.phone }}</div>
      </div>
      <div class="message">
        <div class="message_left">开通时间: {{ formInline.timeOpen }}</div>
        <div class="message_right">到期时间: {{ formInline.timeExpire }}</div>
      </div>
    </div>
    <div class="title">
      申请使用
    </div>
    <div class="fundamental">
      <div class="message">
        <div class="message_left">申请时间: {{ userid.timeApply }}</div>
        <div class="message_right">审核状态: {{ userid.statusDes }}</div>
      </div>
      <div class="message">
        <div class="message_left">订单金额: {{ userid.originalPrice }} 元</div>
        <div class="message_right">实付金额: {{ userid.presentPrice }} 元</div>
      </div>
      <div class="itemimg">
        <div class="textcent">订单截图:</div>
        <div class="imglist" v-for="(item, index) in image" :key="index">
          <img style="width: 150px; height: 150px" :src="item" alt="" />
        </div>
      </div>
      <div class="textbotoon">
        <span>备注:</span>
        <span class="sptwo"
          >住客通过{{ userid.source }}下单，订单编号: {{ userid.id }}</span
        >
      </div>
    </div>
    <div class="title">
      操作记录
    </div>
    <el-table
      ref="multipleTable"
      :data="tenanttableData"
      tooltip-effect="dark"
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column prop="operator" label="审核人"> </el-table-column>
      <el-table-column prop="timeUpdate" label="审核时间"> </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { getlistVip, getvipApprove } from "../../api/index";
export default {
  data() {
    return {
      // 用户信息数据
      formInline: {
        phone: "",
        city: "",
        timeExpire: "",
        timeOpen: "",
        timeUpdate: "",
        id: ""
      },
      // 操作和记录数据
      userid: {
        images: [],
        originalPrice: "",
        presentPrice: "",
        statusDes: "",
        timeApply: "",
        source: "",
        id: ""
      },
      image: [],

      tenanttableData: [],
      headers: {
        Authorization: "Bearer " + window.sessionStorage.getItem("user_token")
      }
    };
  },
  created() {
    if (this.$route.params.id) {
      sessionStorage.setItem("themmeid", this.$route.params.id); //将params中的值存在本地，并且当他为空时不刷新
    }
    this.setlist();
  },
  methods: {
    setlist() {
      this.formInline.phone = sessionStorage.getItem("themmephone");
      this.formInline.id = sessionStorage.getItem("themmeid");
      let data = {
        phone: this.formInline.phone
      };
      let datace = {
        id: this.formInline.id
      };
      // console.log(data);
      getlistVip(data).then(res => {
        let data = res.data.data.list;

        this.formInline = data[0];
        // console.log(res.data.data.list);
      });
      getvipApprove(datace).then(res => {
        let data = res.data.data.list;
        // console.log(res.data.data.list);
        this.userid = data[0];
        this.tenanttableData = data;
        this.image = data[0].images;
        console.log(this.userid);
      });
    },

    handleSelectionChange() {}
  }
};
</script>

<style lang="less" scoped>
.title {
  position: relative;
  width: 85%;
  height: 26px;
  line-height: 26px;
  font-size: 20px;
  text-indent: 15px;
}
.title::before {
  position: absolute;
  left: 0px;
  top: -3px;
  height: 36px;
  width: 6px;
  content: "";
  border-radius: 3px;
  background-color: #f6b439;
}
/deep/.el-table__header-wrapper {
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.15);
  height: 50px;
  border-radius: 0px;
  .el-table__header {
    height: 50px;
    tr {
      height: 50px;
      th {
        background-color: #f2f2f2;
        text-align: center;
      }
    }
  }
}
/deep/ .el-table__row td {
  text-align: center;
  height: 60px;
  padding: 4px 0;
}
.fundamental {
  margin-top: 25px;
  padding: 20px 15px;
  margin-bottom: 60px;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  .message {
    position: relative;
    height: 45px;
    font-size: 16px;
    .message_left {
      position: absolute;
      top: 0px;
      left: 0px;
      line-height: 45px;
    }
    .message_right {
      position: absolute;
      top: 0px;
      left: 548px;
      line-height: 45px;
    }
  }
  .itemimg {
    margin-top: 50px;
    height: 148px;
    display: flex;
    flex-direction: row;
    align-items: center;
    .textcent {
      font-size: 16px;
    }
    i.el-icon-plus {
      margin-top: 58px;
    }
    .imglist {
      margin-left: 15px;
    }
  }
  .textbotoon {
    font-size: 16px;
    margin: 20px 0 0 31px;
    .sptwo {
      margin-left: 15px;
    }
  }
}
</style>
